import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/runningReport',
  component: LAYOUT,
  name: 'runningReport',
  redirect: '/runningReport/index',
  meta: {
    title: '行车报告',
  },
  children: [
    {
      path: 'index',
      name: 'runningReport',
      meta: {
        title: '行车报告',
      },
      component: () => import('@/views/runningReport/index'),
    },
  ],
};
